import { render, staticRenderFns } from "./AutoStart.vue?vue&type=template&id=81569512&scoped=true"
import script from "./AutoStart.vue?vue&type=script&lang=js"
export * from "./AutoStart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81569512",
  null
  
)

export default component.exports